import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DataFieldComponentBase } from './datafield-base-component';

@Component({
    selector: 'ep-datafield-dropdown',
    templateUrl: './datafield-dropdown.component.html',
    inputs: ['isAlwaysEditable', 'datafield', 'formValidationGroup'],
    outputs: ['valueChanged'] // It's necessary to set this, because the valueChanged method is placed in the base-class and not inherited if this is not set.
    ,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule, ReactiveFormsModule]
})

export class DataFieldDropDownComponent extends DataFieldComponentBase {

    constructor() {
        super();
    }

    override ngOnInit() {
        if (this.isAlwaysEditable || this.isEditable) {
            this.formValidationGroup.controls[this.validationIdentifier].enable();
        }
        else {
            this.formValidationGroup.controls[this.validationIdentifier].disable();
        }
    }

    onModelChange($event: Event) {
        this.datafield.Value = $event;
        this.notifyValueChanged(this.datafield);
    }

    // Inherited properties - because of the lack of decorator-inheritance
    //@Input() public isAlwaysEditable: boolean;
    //@Input() public datafield: DataField;
    //@Input() public formValidationGroup: FormGroup;

    get isValid() {
        if ((this.formValidationGroup.disabled ) || this.formValidationGroup.controls[this.validationIdentifier].disabled) {
            return true;
        }

        return this.formValidationGroup.controls[this.validationIdentifier].valid === true;
    }

    override edit() {
        super.edit();
        this.formValidationGroup.controls[this.validationIdentifier].enable();
    }

    override cancel() {
        super.cancel();
        this.formValidationGroup.controls[this.validationIdentifier].disable();
    }
}
